import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';

import { environment } from 'src/environments/environment';
import { AuthResponse, LoginRequest, UserProfile } from '../models/session';
import { BehaviorSubject } from 'rxjs';
import { UserResponse } from '../models/user';

const ENDPOINT = environment.endpoint;

@Injectable({
	providedIn: 'root'
})
export class AuthenticationService {
	private phoneId = new BehaviorSubject<string>('');
	phoneId$ = this.phoneId.asObservable();

	private username = new BehaviorSubject<string>('');
	username$ = this.username.asObservable();

	constructor(private httpClient: HttpClient, private router: Router) {}

	getToken() {
		return sessionStorage.getItem('access_token');
	}

	/** Return true if user is logged in */
	get isLoggedIn(): boolean {
		const authToken = sessionStorage.getItem('access_token');
		return authToken !== null ? true : false;
	}

	/** Return username is user is logged in */
	shareUsername(username: string) {
		this.username.next(username);
	}

	/** Return true is user has role */
	get hasRole(): boolean {
		const role = sessionStorage.getItem('role');
		return role !== null ? true : false;
	}

	login(body: LoginRequest): Observable<AuthResponse> {
		return this.httpClient.post<AuthResponse>(`${ENDPOINT}/Authentication/Login`, body);
	}
	/*
	getAccessRole(user: string): Observable<any> {
		return this.httpClient.get<any>(`${ENDPOINT}/Users?name=${user}`);
	}*/
	getProfile(): Observable<UserResponse> {
		return this.httpClient.get<UserResponse>(`${ENDPOINT}/Authentication/Me/Profile`);
	}

	logout(): Observable<any> {
		sessionStorage.removeItem('access_token');
		this.router.navigate([ '/auth/login' ]);
		return of(null);
		//return this.httpClient.post(`${ENDPOINT}/Users/Logout`, null);
	}
}
